import { render, staticRenderFns } from "./PriceListCommonFilters.vue?vue&type=template&id=55281ced&"
import script from "./PriceListCommonFilters.vue?vue&type=script&lang=js&"
export * from "./PriceListCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports